import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ALL_TOKENS, TEAM_LEADERBOARD, TEAM_DETAILS_SETTINGS, TEAM_DETAILS_USERS, MY_TOKENS, TEAM_DETAILS_BADGES, POST_DETAIL, TEAM_USER_STATS } from './TeamHomeRouteConstants';
import { TEAM_HOME } from 'router/routerConstants';
import * as Components from '../components';

const TeamHomeRouteSwitch: React.FC = () => {
	return (
		<Switch>
			<Route {...ALL_TOKENS} component={Components.AllTokens} />
			<Route {...TEAM_LEADERBOARD} component={Components.Leaderboard} />
			<Route {...TEAM_DETAILS_SETTINGS} component={Components.TeamSettings} />
			<Route {...TEAM_DETAILS_USERS} component={Components.TeamUsers} />
			<Route {...TEAM_DETAILS_BADGES} component={Components.TeamBadges} />
			<Route {...POST_DETAIL} component={Components.SinglePost} />
			<Route {...MY_TOKENS} component={Components.MyTokens} />
			<Route {...TEAM_USER_STATS} component={Components.MyStats} />
			<Route path={TEAM_HOME.path} render={() => <Redirect to={`${TEAM_HOME.path}/all`} />} />
		</Switch>
	);
};

export default TeamHomeRouteSwitch;
